import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { subscribeFollow, unsubscribeFollow, getFollowedTournaments as fetchFollowedTournaments } from '@/api/strapi/follow';

export const useFollowStore = defineStore('follow', () => {
    // State
    const followedTournaments = ref(JSON.parse(localStorage.getItem('followedTournaments')) || []);
    const isLoading = ref(false);
    const error = ref(null);

    // Getters
    const isFollowing = computed(() => (tournamentId) => {
        return followedTournaments.value.some(t => t.id === tournamentId || t.documentId === tournamentId);
    });

    const followedTournamentIds = computed(() => {
        return followedTournaments.value.map(t => t.id || t.documentId);
    });

    // Actions
    const loadFollowedTournaments = async () => {
        try {
            isLoading.value = true;
            error.value = null;
            const data = await fetchFollowedTournaments();
            followedTournaments.value = data || [];
            localStorage.setItem('followedTournaments', JSON.stringify(followedTournaments.value));
            return followedTournaments.value;
        } catch (err) {
            console.error('Lỗi khi tải danh sách giải đã theo dõi:', err);
            error.value = err.message || 'Có lỗi xảy ra khi tải danh sách giải đã theo dõi';
            throw err;
        } finally {
            isLoading.value = false;
        }
    };

    const toggleFollowTournament = async (tournamentId) => {
        try {
            isLoading.value = true;
            error.value = null;
            
            const isCurrentlyFollowing = isFollowing.value(tournamentId);
            
            if (isCurrentlyFollowing) {
                await unsubscribeFollow(tournamentId);
                followedTournaments.value = followedTournaments.value.filter(t => 
                    t.id !== tournamentId && t.documentId !== tournamentId
                );
                // Cập nhật localStorage
                localStorage.setItem('followedTournaments', JSON.stringify(followedTournaments.value));
            } else {
                await subscribeFollow(tournamentId);
                // Làm mới danh sách từ server để có dữ liệu mới nhất
                await loadFollowedTournaments();
            }
            
            return !isCurrentlyFollowing;
        } catch (err) {
            console.error('Lỗi khi thay đổi trạng thái theo dõi:', err);
            error.value = err.message || 'Có lỗi xảy ra khi thay đổi trạng thái theo dõi';
            throw err;
        } finally {
            isLoading.value = false;
        }
    };

    // Khởi tạo
    const init = async () => {
        if (localStorage.getItem('user')) {
            await loadFollowedTournaments();
        }
    };

    // Gọi init khi store được tạo
    init();

    return {
        // State
        followedTournaments,
        isLoading,
        error,
        
        // Getters
        isFollowing,
        followedTournamentIds,
        
        // Actions
        loadFollowedTournaments,
        toggleFollowTournament,
    };
});
